import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListView } from '@app/core/list-view/ListView';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { webApi } from '@mi-front/api-clients';
import { Paginated } from '@mi-front/core';
import { fetchYoutubeCuepoints } from './api/fetch-youtube-cuepoints';
import { YOUTUBE_CUEPOINTS_FILTERS_CONFIG } from './filters/youtube-cuepoints-filters-config';
import { InsertCuepointButton } from './insert-cuepoint/InsertCuepointButton';
import { YoutubeCuepointsTable } from './YoutubeCuepointsTable';

interface Props {
  stationId: string;
}

/**
 * ListView-backed cuepoints list for a station via BFF `/youtube-cuepoints`.
 */
export function YoutubeCuepointsList({ stationId }: Props) {
  const timezone = useTimezone();
  const listId = `youtube-cuepoints-${stationId}`;

  const queryFn = async (params: ListViewQueryParams): Promise<Paginated<webApi.CuepointDto>> => {
    return fetchYoutubeCuepoints(stationId, params, timezone);
  };

  return (
    <ListView
      listId={listId}
      queryFn={queryFn}
      filters={YOUTUBE_CUEPOINTS_FILTERS_CONFIG}
      actions={[
        <InsertCuepointButton key="insert-cuepoint" stationId={stationId} listId={listId} />,
      ]}
      ListComponent={YoutubeCuepointsTable}
      defaultPageSize={50}
    />
  );
}
